import Header1 from "./modules/Header1";
import Footer1 from "./modules/Footer1";
import News1 from "./modules/News1";
import Request1 from "./modules/Request1";
import Accordion1 from "./modules/Accordion1";
import Pagenav2 from "./modules/Pagenav2";
import Pagenav3 from "./modules/Pagenav3";
import SmoothScroll1 from "./modules/SmoothScroll1";
import Top1 from "./modules/Top1";
import ScrollTrigger1 from "./modules/ScrollTrigger1";

const init = () => {
  new Header1();
  new Footer1();
  new News1();
  new Request1();
  new Accordion1();
  new Pagenav2();
  new Pagenav3();
  new SmoothScroll1();
  new Top1();
  new ScrollTrigger1();
};

window.addEventListener("DOMContentLoaded", () => {
  init();
});
